const openers = new Set();

const dimmer = document.querySelector(".full-screen-dimmer");

window.openFullDimmer = (opener) => {
  openers.add(opener);
  dimmer.classList.add("dimmer--active");
};

window.closeFullDimmer = (opener) => {
  openers.delete(opener);

  if (!openers.size) {
    dimmer.classList.remove("dimmer--active");
  }
};
